"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.create.title': '创建新步骤',
};
